<template>
  <Card title="Társaság adatai">
    <template v-slot:body>
      <h6 class="mb-0">Név</h6>
      <div>{{ $store.state.inspection.selected.details.member.name }}</div>
      <h6 class="mb-0">Nyilvántartási szám</h6>
      <div>{{ $store.state.inspection.selected.details.member.membership_number }}</div>
      <h6 class="mb-0">Cím</h6>
      <div>
        <span>{{ $store.state.inspection.selected.details.member.address }}</span>
        <b-button class="text-button-height-modifier"
                  @click="$store.dispatch(
                    'openModal',
                  { modalName: 'GoogleMapsModal',
                           data: { address: $store.state.inspection.selected.details.member.address }
                  })"
                  icon-left="map-pin"
                  type="is-ghost">
          Mutat
        </b-button>
      </div>
    </template>
  </Card>
</template>

<script>
import Card from '@/components/Cards/Common/Card'

export default {
  name: 'CompanyDetailsCard',
  components: { Card },
}
</script>

<style scoped>

</style>
